const o="/support/request/save",s="supportModal";export{o as SUPPORT_MODAL_SAVE_URL,s as REDUCER_SUPPORT_MODAL_NAME};
